import angular from 'angular';

angular.module('app.core').factory('DiscardedIdentifier', DiscardedIdentifier);

export default class DiscardedIdentifier {
    constructor(discardedIdentifier) {
        this.id = discardedIdentifier ? discardedIdentifier.id : null;
        this.idFiscalKind = discardedIdentifier ? discardedIdentifier.idFiscalKind : null;
        this.idFiscal = discardedIdentifier ? discardedIdentifier.idFiscal : null;
        this.discardDate = discardedIdentifier ? discardedIdentifier.discardDate : null;
    }

    getIdFiscalKindLabel() {
        if (this.idFiscalKind) {
            return 'identifiant.type.' + angular.lowercase(this.idFiscalKind);
        }
        return '';
    }
}
